export default {

// SECTION TOP
    title: `A company with a mission`,
    subTitle:`Profiting the future`,
    authorName: `By Matthieu Perotin, journalist.`,


// CONTENT

    content1: `Taking social and environmental issues into account is pretty much par for the course for any company today. <br/>This begs the question of how to clearly identify those organisations wishing to transform themselves through the adoption of truly sustainable business models. In France, the Pacte law, passed in 2018, supplies one answer by creating the entreprise à mission, or "mission-driven company" incorporation class. This model has also been rolled out in Italy with the <em>Società Benefit</em> or in the United States, with the <em>benefit corporation</em>. This has also inspired other European countries to follow suit, as evidenced by the first European congress of mission-driven companies last spring.`,

    content2: `To obtain this mission-driven status, the company must include a mission in its statutes, set up a mission committee and communicate its social and environmental objectives, the execution of which will be verified by an independent body. Reinforcement of the coherence between strategy and communication, better alignment between economic performance and extra-financial issues, and increased employer brand profile, are potentially some of the beneficial effects associated with the transition to a mission-driven company.`,

    title3: `The initiatives`,
    content3_1: `Being a mission-driven company means making commitments to implementing its mission at every level of the organisation. In June 2020, Danone became the first listed French company to adopt the status of a mission-driven company. The company has included four social and environmental objectives in its statutes, all aligned with the United Nations Sustainable Development Goals. Namely: to improve health, preserve the planet and renew its resources, build the future with its teams and promote inclusive growth.`,
    content3_2: `The leader in the home help sector, the company Alenvi is aiming to humanise the support for the elderly. This mission logic has transformed the decision-making process within the organisation by giving it a single direction, that is clear and shared by all.`,
    content3_3: `The Californian clothing company Patagonia was one of the first to adopt this status, through the statement of its desire to help save the planet. To do this, it did not hesitate to reorganise its governance. The CSR department has been dissolved in order to integrate its new mission at the very heart of each of the core businesses. Today, every employee is recruited at Patagonia as much for their determination to protect nature as for their skills.`,


// KEY FIGURES
    keyFigures: [
        {
            figure: 2,
            prefix: `X&nbsp;`,
            content: `In France, the number of mission-driven companies doubled between the end of 2020 and the end of 2021 – from 207 to 505. In total, 530,000 employees are concerned.`,
            topImage: `Profiting_001.svg`,
            noCollapse: true,
        },
        {
            figure: 80,
            prefix: `Nearly&nbsp;`,
            suffix: `%`,
            content: `The majority of companies with a mission are present in the service sector. Trade (11%) and industry (9.5%) come next.`,
            topImage: `Profiting_002.svg`,
            noCollapse: true,
            noMarge: true,
        },

    ],


};

